import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import { MdKeyboardArrowDown as DownArrow } from 'react-icons/md';
import { MdKeyboardArrowUp as UpArrow } from 'react-icons/md';
import { CardText } from 'material-ui/Card';
import {
  BarChart,
  Bar,
  XAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  YAxis,
  LabelList,
} from 'recharts';
import { colors } from 'helpers/ColorHelper';
import { getTimeRange } from 'helpers/DateHelper';

const style = {
  transactionCard: {
    color: '#424242 !important',
    fontFamily: '"Circular", sans-serif !important',
    height: '100%',
    overflow: 'hidden',
    borderRadius: '8px',
    boxShadow: '1px 4px 15px rgba(0, 0, 0, 0.15)',
    padding: '15px',
  },
};

class TicketsCategoryChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: false,
      timeseries: false,
    };
  }

  getData = () => {
    const { graphData, level } = this.props;
    const categories = graphData[level].opened_categories_count;
    return Object.keys(categories).map((category) => {
      return {
        Category: category,
        Low: categories[category]['Low'],
        Normal: categories[category]['Normal'],
        High: categories[category]['High'],
        Emergency: categories[category]['Emergency'],
      };
    });
  };

  getTimeSeriesData = () => {
    const { graphData, level } = this.props;
    const timeRange = graphData[level].time_range;
    const categoriesByTime = graphData[level].series_opened_categories_count;

    return Object.keys(categoriesByTime).map((timePeriod) => {
      const time = getTimeRange(timePeriod, timeRange);
      const category_results = Object.keys(categoriesByTime[timePeriod]).map((category) => ({
        time: time,
        [`${category}-Low`]: categoriesByTime[timePeriod][category]['Low'],
        [`${category}-Normal`]: categoriesByTime[timePeriod][category]['Normal'],
        [`${category}-High`]: categoriesByTime[timePeriod][category]['High'],
        [`${category}-Emergency`]: categoriesByTime[timePeriod][category]['Emergency'],
        category: category,
      }));
      return Object.assign({}, ...category_results);
    });
  };

  classSize = () => {
    const { timeSeries } = this.props;
    if (timeSeries) {
      return 'col-sm-12';
    }
    return 'col-sm-6';
  };

  showHide = () => {
    this.setState((prevState) => ({ hidden: !prevState.hidden }));
  };

  render() {
    const { graphData, level } = this.props;
    const { hidden } = this.state;
    if (!graphData[level].children) return null;
    if (graphData[level].childen && graphData[level].childen.length === 0) return null;

    return (
      <div className={this.classSize()}>
        <div className="row" style={{ padding: '0', height: '100%' }}>
          <h3 style={{ padding: '0 15px', marginBottom: '20px' }}>
            <button
              type="button"
              className="link-button"
              onClick={this.showHide}
              style={{ color: 'inherit' }}
            >
              Tickets Per Category
              <span>
                {hidden && <UpArrow size={24} />}
                {!hidden && <DownArrow size={24} />}
              </span>
            </button>
          </h3>
          {this._renderGraph()}
        </div>
      </div>
    );
  }

  _renderCustomizedLabel = ({ x, y, stroke, value }) => {
    const transformation = `rotate(-60, ${x}, ${y})`;
    return (
      <text
        x={x + 5}
        y={y + 10}
        dy={-4}
        fill={stroke}
        fontSize={10}
        textAnchor="left"
        transform={transformation}
      >
        {value}
      </text>
    );
  };

  _renderGraph = () => {
    if (this.state.hidden) return null;
    return (
      <div className="row" style={{ padding: '0', height: '100%' }}>
        <Card style={style.transactionCard}>
          <CardText expandable={true} style={{ padding: '0' }}>
            {this._renderLevelGraph()}
            {this._renderTimeSeriesGraph()}
          </CardText>
        </Card>
      </div>
    );
  };

  _renderLevelGraph = () => {
    if (this.props.timeSeries) return null;
    const { showLabels } = this.props;
    const dataMax = showLabels ? 'dataMax + 7' : 'dataMax';

    return (
      <ResponsiveContainer height={300}>
        <BarChart
          width={600}
          height={400}
          data={this.getData()}
          margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
        >
          <XAxis height={60} tick={false} label="Categories" type="category" dataKey="Category" />
          <YAxis
            domain={[0, dataMax]}
            label={{ value: 'Tickets', angle: -90, position: 'insideLeft' }}
          />
          <Legend verticalAlign="top" height={36} />
          <Tooltip />
          <Bar dataKey="Low" fill={colors.BLUE} stackId="a" barSize={20} />
          <Bar dataKey="Normal" fill={colors.GREEN} stackId="a" barSize={20} />
          <Bar dataKey="High" fill={colors.LIGHT_ORANGE} stackId="a" barSize={20} />
          <Bar dataKey="Emergency" fill={colors.RED} stackId="a" barSize={20}>
            {showLabels && <LabelList content={this._renderCustomizedLabel} dataKey="Category" />}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    );
  };

  _renderTimeSeriesGraph = () => {
    if (!this.props.timeSeries) return null;
    const { showLabels, onClick, graphData, level } = this.props;
    const dataMax = showLabels ? 'dataMax + 5' : 'dataMax';
    return (
      <ResponsiveContainer height={300}>
        <BarChart
          width={600}
          height={400}
          data={this.getTimeSeriesData()}
          margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
          onClick={(params) => onClick(params, 'time')}
        >
          <XAxis height={60} type="category" dataKey="time" />
          <YAxis
            domain={[0, dataMax]}
            label={{ value: 'Tickets', angle: -90, position: 'insideLeft' }}
          />
          <Tooltip wrapperStyle={{ pointerEvents: 'auto', overflowY: 'auto', height: '300px' }} />
          {graphData[level].categories.map((category) => {
            return [
              <Bar
                key={`${category}-Low`}
                dataKey={`${category}-Low`}
                fill={colors.BLUE}
                stackId={category}
                barSize={20}
              />,
              <Bar
                key={`${category}-Normal`}
                dataKey={`${category}-Normal`}
                fill={colors.GREEN}
                stackId={category}
                barSize={20}
              />,
              <Bar
                key={`${category}-High`}
                dataKey={`${category}-High`}
                fill={colors.LIGHT_ORANGE}
                stackId={category}
                barSize={20}
              />,
              <Bar
                key={`${category}-Emergency`}
                dataKey={`${category}-Emergency`}
                fill={colors.RED}
                stackId={category}
                barSize={20}
              >
                {showLabels && (
                  <LabelList content={this._renderCustomizedLabel} valueAccessor={() => category} />
                )}
              </Bar>,
            ];
          })}
        </BarChart>
      </ResponsiveContainer>
    );
  };
}

export default TicketsCategoryChart;
